/**
 * @file Match vote decisions enum.
 */

/**
 * @enum VOTE_DECISION
 * @type {{WUT: string, TOTALLY: string, NOPE: string}}
 */
const VOTE_DECISION = {
  WUT: 'WUT',
  TOTALLY: 'TOTALLY',
  NOPE: 'NOPE',
};

/**
 * @enum NUM_REC_VOTE_DECISION
 * @type {{POSITIVE: string, NOT_SURE: string, NEGATIVE: string}}
 */
const NUM_REC_VOTE_DECISION = {
  POSITIVE: 'POSITIVE',
  NOT_SURE: 'NOT_SURE',
  NEGATIVE: 'NEGATIVE',
};

/**
 * @enum VOTE_DECISION
 * @type {{POSITIVE: string, NEGATIVE: string}}
 */
const CONSUMER_MAYBE_VOTE_DECISION = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
};

export { VOTE_DECISION, NUM_REC_VOTE_DECISION, CONSUMER_MAYBE_VOTE_DECISION };
